import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';

@Component({
  selector: 'e5core-ui-work-item-bootstrap',
  templateUrl: './e5-core-ui-work-item-bootstrap.component.html',
  styleUrls: ['./e5-core-ui-work-item-bootstrap.component.css']
})
export class E5CoreUiWorkItemBootstrapComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() workItem: WorkItemModel ;

  constructor() { }

  ngOnInit() {
  }

}
